import {remCalc} from '_themeUtils'

const searchResultsHeader = {
    SearchResultsHeader: {
        baseStyle: () => ({
            resultsHeader: {
                w: 'full',
                pt: 'spacing.6',
                pb: {base: 'spacing.2', md: 'spacing.8', xl: 'spacing.22'},
            },
            resultsHeaderContent: {
                direction: {base: 'column', md: 'row'},
                justify: {base: 'center', md: 'space-between'},
                align: {md: 'flex-end'},
                borderBottom: `${remCalc(1)} solid`,
                borderBottomColor: 'color.border.grey.300',
            },
            resultsTitle: {
                textStyle: {base: 'paragraphMd', md: 'displayXs'},
                textAlign: {base: 'center', md: 'start'},
                py: 'spacing.2',
                letterSpacing: remCalc(1),
            },
            resultsTitleSkeleton: {
                mx: {base: 'auto', md: 'unset'},
                w: 'full',
                maxW: '350px',
                h: {base: '20px', md: '28px'},
                my: 'spacing.2',
            },
        }),
    },
}

export default searchResultsHeader
